import { render, staticRenderFns } from "./eduSorter.vue?vue&type=template&id=673d5fac&scoped=true"
import script from "./eduSorter.vue?vue&type=script&lang=js"
export * from "./eduSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d5fac",
  null
  
)

export default component.exports